import { IPrivateEndpointMetadata as IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getManualResourceIdControl, getReadonlyControl } from './shared-control-metadata';
import { format } from 'app/shared/utils/string.util';
import { azureResourceSelectMethodOptions } from '../consts/metadata-consts';

const resourceId = '/subscriptions/<subscriptionId>/resourceGroups/<resourceGroupName>/providers/Microsoft.Network/applicationGateways/<resourceName>';
const resourceIdFormat = '\/?subscriptions\/.+\/resourceGroups\/.+\/providers\/Microsoft.Network\/applicationGateways\/.+';
export const resourceIdErrorMessage = format(stringResources.InvalidResourceId, resourceId);

export const appGatewayPrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.Network/applicationgateways',
    connectionSuffix: 'privateLink',
    resourceIdValidator: resourceIdFormat,
    groupIdMetadata: {
        appGatewayFrontendIp: {
            linkedServiceType: 'ApplicationGatewayService',
            groupId: '',
            iconClass: 'svg-i-100x100-applicationGateways',
            displayName: stringResources.appGateway,
            controls: {
                creationControls: [{
                    type: 'radio-switch',
                    nested: 1,
                    label: stringResources.AccountSelectionMethodLabel,
                    options: azureResourceSelectMethodOptions,
                    defaultValue: '{privateLinkResourceId != null ? "manual" : "azure"}',
                    isLabelVertical: true,
                    cases: [
                        {
                            caseValue: 'azure',
                            children: [
                                {
                                    type: 'azure-resource-select',
                                    bind: {
                                        resourceName: 'privateLinkResourceId',
                                        subresourceName: 'groupId'
                                    },
                                    resourceTypes: ['Microsoft.Network/ApplicationGateways'],
                                    resourceNameLabel: stringResources.appGateway,
                                    supportSubresource: true,
                                    subresourceApiVersion: '2020-03-01',
                                    subresourceCommand: 'privateLinkResources',
                                    preserveResourceUri: true,
                                    validators: {
                                        resourceName: [
                                            { type: 'required', errorMessage: '' }
                                        ],
                                        subresourceName: [
                                            { type: 'required', errorMessage: '' }
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            caseValue: 'manual',
                            children: [
                                getManualResourceIdControl(
                                    format(stringResources.PrivateEndpointResourceIdPlaceholder, resourceId),
                                    resourceIdFormat,
                                    resourceIdErrorMessage),
                                {
                                    type: 'textbox',
                                    bind: 'groupId',
                                    label: stringResources.TargetSubResource,
                                    required: true,
                                    placeholder: 'appGwPublicFrontendIpIPv4',
                                    description: stringResources.TargetSubResourceDescription,
                                    isLabelVertical: true,
                                    validators: [
                                        { type: 'required', errorMessage: '' }
                                    ],
                                }
                            ]
                        }
                    ]
                }],
                readonlyControls: getReadonlyControl(resourceIdFormat, resourceIdErrorMessage)
            }
        }
    }
};
